import { useMemo } from 'react';
import { SingleUnit } from './equipmentTypes';
import {
    buildDownReasonPieSlicePath,
    getDownReasonPieSlices,
    hasDownReasonChartData,
    parseDownReasonEntries,
} from './equipmentDownReasonUtils';

export const EquipmentDownReasonSection = ({ unit }: { unit: SingleUnit }) => {
    const entries = useMemo(() => parseDownReasonEntries(unit.downReason), [unit.downReason]);

    const chartData = useMemo(() => {
        if (!entries) return null;
        const { slices, total } = getDownReasonPieSlices(entries);
        if (total === 0) return null;

        let currentAngle = 0;
        const slicePaths = slices.map((slice) => {
            const { d, endAngle } = buildDownReasonPieSlicePath(slice.value, total, currentAngle);
            currentAngle = endAngle;
            return { ...slice, d };
        });

        return { slices: slicePaths, total };
    }, [entries]);

    if (!hasDownReasonChartData(unit.downReason) || !chartData) {
        return null;
    }

    return (
        <div className="info-section down-reason-section">
            <div className="section-header-row">
                <h3>Down Reason Classifications</h3>
            </div>
            <h4 className="down-reason-chart-title">Distribution of {chartData.total} Issues</h4>
            <div className="down-reason-chart-container">
                <svg width="200" height="200" viewBox="0 0 200 200" aria-label="Issues distribution pie chart">
                    {chartData.slices.map((slice) => (
                        <path key={slice.label} d={slice.d} fill={slice.color} stroke="white" strokeWidth="2" />
                    ))}
                </svg>
                <div className="down-reason-legend">
                    {chartData.slices.map((slice) => (
                        <div key={slice.label} className="down-reason-legend-item">
                            <span className="down-reason-legend-swatch" style={{ background: slice.color }} />
                            <span>
                                {slice.label}: {slice.value} ({((slice.value / chartData.total) * 100).toFixed(1)}%)
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
